/**
 * Created by Tiger on 28/02/2022.
 */
import React, {useEffect, useState} from 'react';
import {Form, Modal, Switch, Typography} from 'antd';
import actions from '../../redux/action';
import {connect} from 'react-redux';
import i18n from 'i18next';
import {InputItem} from '../../components/inputItem';
import {SelectItem} from '../../components/select-item';
import {Footer, useAliConfigTest} from './util';

function AliConfig(props) {
    const [accessKey, setAccessKey] = useState('');
    const [accessSecret, setAccessSecret] = useState('');
    const [productKey, setProductKey] = useState('');
    const [instanceId, setInstanceId] = useState('');
    const [regionId, setRegionId] = useState('');
    const [useThingModel, setUseThingModel] = useState(false);
    const [testLoading, testAliConfig] = useAliConfigTest();
    const test = () => testAliConfig({
        accessKey, accessSecret, productKey, regionId, useThingModel, instanceId,
    });
    const submit = () => props.onOk({
        aliConfig: {
            accessKey, accessSecret, productKey, regionId, useThingModel, instanceId,
        },
    });

    useEffect(() => {
        if (typeof props?.config === 'object') {
            const {
                accessKey = '',
                accessSecret = '',
                productKey = '',
                regionId = '',
                useThingModel = false,
                instanceId = '',
            } = props?.config ?? {};
            setAccessKey(accessKey);
            setAccessSecret(accessSecret);
            setProductKey(productKey);
            setRegionId(regionId);
            setUseThingModel(useThingModel);
            setInstanceId(instanceId);
        }
    }, [props.config]);
    useEffect(() => {
        props.onRefreshAliHostsList(props.language);
    }, []);
    return (<>
        <Modal
            width={ document.body.clientWidth / 3 }
            title={ i18n.t('edit_ali_iot_info_tip') }
            visible={ props.visible }
            onCancel={ props.onCancel }
            onOk={ submit }
            footer={ <Footer
                onTest={ test }
                onCancel={ props.onCancel }
                onOk={ submit }
                testLoading={ testLoading }
            /> }
            closable={ true }
        >
            <>
                <Form style={ { marginBottom: 20 } }>
                    <SelectItem onChanged={ ({ value }) => {
                        console.log('onSelect:', value);
                        setRegionId(value);
                    } } value={ {value: regionId} } options={ props.aliHostList }
                                placeholder={ i18n.t('please_select') }
                                label={ i18n.t('host_area') }/>
                    <InputItem label={ 'AccessKey' } value={ accessKey }
                               onChange={ event => setAccessKey(event?.target?.value) }/>
                    <InputItem label={ 'AccessSecret' } value={ accessSecret }
                               onChange={ event => setAccessSecret(event?.target?.value) }/>
                    <InputItem label={ 'ProductKey' } value={ productKey }
                               onChange={ event => setProductKey(event?.target?.value) }/>
                    <InputItem label={ 'INSTANCE ID' } value={ instanceId }
                               onChange={ event => setInstanceId(event?.target?.value) }/>
                    <Form.Item style={ { marginTop: 10 } } label={ i18n.t('use_thing_model') }>
                        <Switch defaultChecked={ useThingModel } onClick={ (checked, event) => {
                            setUseThingModel(checked);
                        } }/>
                    </Form.Item>
                </Form>
                <Typography.Text>
                    { i18n.t('access_key_access_secret_tips') } <a target={ '_blank' }
                                                                   href={ '/main/private/device_private/#323-ram-访问控制' }>{ i18n.t('access_key_access_secret_tips2') }</a>
                    { i18n.t('product_key_tip') } <a target={ '_blank' }
                                                     href={ '/main/private/device_private/#322-创建产品' }>{ i18n.t('product_key_tip2') }</a>
                </Typography.Text>
            </>
        </Modal>
    </>);
}

const mapStateToProps = state => {
    return {
        language: state.language.language, aliHostList: state.config.aliHostList,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRefreshAliHostsList: language => dispatch(actions.onRefreshAliHostsList(language)),
    };
};

// AliConfig.whyDidYouRender = true;

export default connect(mapStateToProps, mapDispatchToProps)(AliConfig);
